<template>
  <div class="wrap">
    <div class="content">
      <div class="box-input box-phone">
        <div>
          <div class="moblieWrap">
            <div class="inputItem">
              <div class="input-right">
                <input
                  class="mobileInput"
                  v-model="postForm.redeemCode"
                  :maxlength="16"
                  placeholder="请输入兑换码"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <van-button
        class="loginBtn"
        :loading="loginLoading"
        :loading-text="loadingText"
        @click="submit"
        >确定</van-button
      >
    </div>
  </div>
</template>
<script>
import group from '../common/group'
import utils from '../../utils/index.js'
import wx_tools from '../common/wx_tools.js'

export default {
  name: 'redeem',
  components: {},
  data() {
    return {
      user: {},
      token: '',
      tokenKey: 'tokenKey',
      loginLoading: false,
      loadingText: '正在兑换...',
      wxThirdid: undefined,
      wxThirdidKey: 'wxThirdidKey',
      postForm: {
        redeemCode: ''
      }
    }
  },
  mounted() {
    document.title = '雪梨英语'
    this.wxThirdid = localStorage.getItem(this.wxThirdidKey)
    if(!this.wxThirdid){
      this.$toast("页面错误，请重试")
      localStorage.clear()
      let timer = setTimeout(() => {
        clearTimeout(timer)
        this.$router.replace({
          name:'login'
        })
      }, 1000);
      return
    }
    this.token = localStorage.getItem(this.tokenKey)
    this.getUser()
    console.log('redeem', this.token)
    this.initShare()
  },
  watch: {},
  methods: {
    getUser() {
      const params = { token: this.token }
      group.userGet
        .call(this, params)
        .then((res) => {
          console.log('用户信息', res)
          if (res.data.success) {
            this.user = res.data.data
          } else {
            this.$toast(res.data.error.msg)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },

    // 登录
    submit() {
      if (!this.postForm.redeemCode) {
        this.$toast('请输入兑换码')
        return
      }

      this.loginLoading = true
      const params = {
        token: this.token,
        redeemCode: this.postForm.redeemCode,
      }
      utils.tools.showLoading()
      group.redeem
        .call(this, params)
        .then((res) => {
          // this.loginLoading = false
          console.log('兑换结果', res)
          // utils.tools.hideLoading()
          if (res.data.success) {
            this.$toast('兑换成功')
            this.$toast('开课中...')
            const openParams = {token:this.token, thirdId:this.wxThirdid}
            group.open
              .call(this, openParams)
              .then((res) => {
                this.loginLoading = false
                utils.tools.hideLoading()
                console.log('开课结果', res)
                if (res.data.success) {
                  this.$toast('开课成功')
                } else {
                  this.$toast(res.data.error.msg)
                }
                setTimeout(() => {
                  this.$router.back(-1)
                }, 1000)
              })
              .catch((error) => {
                this.loginLoading = false
                utils.tools.hideLoading()
                console.log(error)
              })

          } else {
            this.$toast(res.data.error.msg)
            this.loginLoading = false
          }
        })
        .catch((error) => {
          utils.tools.hideLoading()
          this.loginLoading = false
          console.log(error)
        })
    },
    initShare() {
      console.log('调用initShare')
      const tempJumpLink = utils.config.config.shareUrl
      // 分享字数规则：主标题两行，副标题3行，超出全部...
      let shareObj = {
        debug: false,
        referer: tempJumpLink,
        appId: utils.config.config.appId,
        title: utils.config.config.shareMainTitle,
        desc: utils.config.config.shareDesTitle,
        link: tempJumpLink,
        imgUrl: utils.config.config.shareImgUrl,
        type: '', // 分享类型,music、video或link，不填默认为link
        dataUrl: '' // 如果type是music或video，则要提供数据链接，默认为空
        // success: this.shareSuccess
        // fail: this.shareFail
      }
      console.log('分享跳转地址--login', shareObj)
      wx_tools.initShare.call(this, shareObj)
    }
  }
}
</script>

<style src="./index.css" scoped></style>
<style scoped></style>
